import {
  CheckboxButton,
  CheckboxField,
  FieldError,
  Text,
  type CheckboxFieldProps,
} from 'react-aria-components';

import styles from './Checkbox.module.css';

export interface CheckboxProps extends Omit<
  CheckboxFieldProps,
  'children' | 'className' | 'style' | 'isIndeterminate'
> {
  /** What ticking it means, e.g. "Estimated age". */
  children: string;
  /** One line under the label. */
  description?: string;
  /** What is wrong and how to fix it. Setting it marks the checkbox invalid. */
  errorMessage?: string;
}

/** A single yes-or-no choice. For one of several choices, use `RadioGroup`. */
export function Checkbox({
  children,
  description,
  errorMessage,
  isInvalid,
  ...rest
}: CheckboxProps) {
  return (
    <CheckboxField
      {...rest}
      isInvalid={isInvalid === true || errorMessage !== undefined}
      className={styles.field}
    >
      <CheckboxButton className={styles.checkbox}>
        <span className={styles.box} aria-hidden="true">
          <span className={styles.tick} />
        </span>
        <span>{children}</span>
      </CheckboxButton>
      {description === undefined ? null : (
        <Text slot="description" className={styles.description}>
          {description}
        </Text>
      )}
      <FieldError className={styles.error}>{errorMessage}</FieldError>
    </CheckboxField>
  );
}
